import { INode, Node } from "./layer-node.model";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IRootNode extends INode {
}

export class RootNode extends Node implements IRootNode {
    constructor(type?: string) {
        super(undefined, type);
        this.nodeType = "root";
    }
}
